import { App, Poller } from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { SKIP_MATCH_LIST_INITIAL_REQUEST } from 'app-constants';
import { usePureSelector, useWithLocation } from 'hooks';
import matchList from 'modules/match-list';
import { checkSkipPollerConfiguration } from 'utils';

const {
    actions: { searchMatches },
    selectors: { selectFetchStatus },
    pagination: {
        selectors: { selectIsPollingTurnedOff },
    },
} = matchList;

const POLLER_NAME = App.PollerName.Live;

interface Output {
    fetchStatus: App.FetchStatus;
    pollerOpts: Poller.UsePollerInput<typeof searchMatches>;
}

export default function useLive(): Output {
    const { location, isSkipInitialRequest } = useWithLocation(l => ({
        location: l,
        isSkipInitialRequest:
            !window.__app.previousLocation &&
            checkSkipPollerConfiguration(
                SKIP_MATCH_LIST_INITIAL_REQUEST[App.Routes.LIVE_LIST]
            ),
    }));

    const { fetchStatus, isPollingTurnedOff } = usePureSelector(s =>
        selectProps(s, { location })
    ); // NOTE: selectFetchStatus and selectIsPollingTurnedOff need of location

    return {
        fetchStatus,
        pollerOpts: {
            pollerName: POLLER_NAME,
            executableAction: searchMatches,
            skipInitialRequest: isSkipInitialRequest,
            isPollingTurnedOff,
        },
    };
}

const selectProps = createStructuredSelector({
    fetchStatus: selectFetchStatus,
    isPollingTurnedOff: selectIsPollingTurnedOff,
});
